import React, { Component } from "react";
import styled from "styled-components";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

// result pencarian
import Pencarian from "./Pencarian";

const TableWrapper = styled.div`
  min-width: 100%;
  margin-bottom: 2em;
`;

const Title = styled.h2`
  font-size: 2.2rem;
  font-weight: 700;
  margin-right: auto;
  letter-spacing: -0.5px;
`;

class PenerimaHibah extends Component {
  render() {
    return (
      <TableWrapper>
        <Title>Pencarian Donatur</Title>
        <p>Pencarian Donatur Penanggulangan Pandemi COVID-19</p>
        <Pencarian />
      </TableWrapper>
    );
  }
}

export default PenerimaHibah;
